import { useCallback } from 'react';

export const useScrollLock = () => {
  const setScrollLock = useCallback((isLocked: boolean) => {
    return isLocked
      ? document.body.classList.add('body--scroll-locked')
      : document.body.classList.remove('body--scroll-locked');
  }, []);
  return { setScrollLock };
};
